import * as React from 'react';
import { useState, useRef, useEffect } from 'react';
import moment from "moment";
import { ajax } from "jquery";
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import Button from '../../components/forms/button';
import ContentTitle from '../../components/common/container/title';
import InlineInput from '../../components/forms/inlineinput';
import InlineData from '../../components/forms/inlinedata';
import Checkbox from '../../components/forms/checkbox'
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import IRC0111_1Table from "./irc0111_1-table";

import Translate from '../../components/common/translate';
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import ja from "date-fns/locale/ja";

var jaLocale = {
    ...ja,
    options: {
        weekStartsOn: 0, firstWeekContainsDate: 1
    }
}
registerLocale('ja', jaLocale);
const getTranslateValue = Utils.getTranslateValue;

const API = {
    GETBILLINGDETAILSINFO: window.domainDir + "api/Billing/GetBillingDetailsInfo",
    VALIDATEIRAI: window.domainDir + "api/Billing/ValidateIrai",
    CANCELBILLING: window.domainDir + "api/Billing/DeleteBillingRequest"
};

const URLPath = {
    IRC0101: "/Billing/Search",
    IRC0111: "/Billing/Details",
    IRC0111_2: "/Billing/Delete/Details"
}

const SESSION_KEYS = {
    IRAINO: 'bbmedical_iraino',
    SHOWPASSWORD: 'bbmedical_showpassword'
}

const IRC0111_1_Master = (props) => {
    let translate = useRef(null);
    let history = useHistory();

    const [currentPage, setPageNo] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [isFetching, setLoadingState] = useState(false);
    const [isFacilityLoaded, setFacilityLoaded] = useState(false);

    const [translateSuccess, setTranslateSuccess] = useState(false);

    const [iraiNo, setIraiNo] = useState(null);
    const [promotionalItemList, setPromotionalItemList] = useState([]);
    const [sendDeleteCompletionEmail, setSendDeleteCompletionEmail] = useState(false);
    const [deliveredItems, setDeliveredItems] = useState([]);
    const [facility, setFacility] = useState({
        IraiStatus: 0,
        PostalCode: "",
        Address: "",
        FacilityName: "",
        KanjiName: "",
        KanaName: "",
        DepartmentName: "",
        Phone: "",
        Fax: "",
        Email: "",
        DateShipped: "",
        InvoiceNumber: "",
        DeliveryCompany: "",
        HasShuka: false
    });

    useEffect(() => {
        $("#loading").fadeIn();
        initFromSession().always(() => $("#loading").fadeOut());
    }, []);

    function initFromSession() {
        const rawNo = sessionStorage.getItem(SESSION_KEYS.IRAINO);
        const rawPw = sessionStorage.getItem(SESSION_KEYS.SHOWPASSWORD);

        // if missing, go back to IRC0101 screen
        if (!rawNo || !rawPw) {
            history.replace(URLPath.IRC0101);
            return $.Deferred().resolve(); 
        }

        // validate first before displaying details
        return ajax({
            url: API.VALIDATEIRAI,
            type: 'GET',
            data: { iraiNo: rawNo, password: rawPw },
            credentials: 'same-origin',
            dataType: "json"
        })
            .done(function (res) {
                let payload = null;
                if (res) {
                    if (res.Response !== undefined && res.Response !== null) {
                        payload = res.Response;
                    } else if (res.data !== undefined && res.data !== null) {
                        payload = res.data;
                    }
                }
                const isValid = payload && payload.IsValid === true;

                if (!isValid) {
                    history.replace(URLPath.IRC0101);
                } else {
                    setIraiNo(Number(rawNo));
                    fetchBillingDetails(Number(rawNo));
                }
            })
            // .always(function () {
            //     sessionStorage.removeItem(SESSION_KEYS.IRAINO);
            //     sessionStorage.removeItem(SESSION_KEYS.SHOWPASSWORD);
            // });
    }

    function fetchBillingDetails(iraiNo) {
        return ajax({
            url: API.GETBILLINGDETAILSINFO,
            type: 'GET',
            data: { iraiNo: iraiNo },
            credentials: 'same-origin',
            dataType: "json"
        })
            .done(function (res) {
                var payload = null;
                if (res) {
                    if (res.Response !== undefined && res.Response !== null) {
                        payload = res.Response;
                    } else if (res.data !== undefined && res.data !== null) {
                        payload = res.data;
                    }
                }
                if (!payload) return;

                var irai = payload.Irai || null;
                var details = payload.Details || [];
                setPromotionalItemList(details);
                var shuka = payload.Shuka || null;
                var haiso = payload.Haiso || null;

                // Header / facility
                setFacility({
                    IraiStatus: (irai && irai.IraiStatus) || 0,
                    PostalCode: (irai && irai.ZipNo) || "",
                    Address: [irai && irai.Todofuken, irai && irai.Address1, irai && irai.Address2, irai && irai.Address3].filter(Boolean).join(""),
                    FacilityName: (irai && irai.IraiFacilityName) || "",
                    KanjiName: (irai && irai.IraishaName) || "",
                    KanaName: (irai && irai.IraishaNameKana) || "",
                    DepartmentName: (irai && irai.IraiDepartmentName) || "",
                    Phone: (irai && irai.Tel) || "",
                    Fax: (irai && irai.Fax) || "",
                    Email: (irai && irai.Email) || "",
                    DateShipped: (shuka && shuka.ShukaDt) ? moment(shuka && shuka.ShukaDt).format("YYYY/MM/DD") : "",
                    InvoiceNumber: (shuka && shuka.HaisoDenNo) || "",
                    DeliveryCompany: (haiso && haiso.HaisoName) || "",
                    HasShuka: !!shuka
                });

                // Table rows
                var rows = (details || []).map(function (d, idx) {
                    return {
                        Id: idx + 1,
                        ImgSrc: d.ImgSrc || "/img/big%20bell/noimage.jpg",
                        CategoryName: d.CategoryName || "",
                        PromotionalItemName: d.HansokuName || "",
                        PromotionalItemCode: d.HansokuCode || "",
                        BillingQuantity: d.IraiQt || 0
                    };
                });
                setDeliveredItems(rows);
                setFacilityLoaded(true);
            })
            .fail(function () {
                setStatusMessage(CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
                setFacilityLoaded(true);
            })
    }

    function handleCancelBilling(){
        $("#loading").fadeIn();
        ajax({
            url: API.CANCELBILLING,
            type: 'POST',
            data: { iraiNo: iraiNo, sendEmail: sendDeleteCompletionEmail, vHansokus: JSON.stringify(promotionalItemList) },
            credentials: 'same-origin'
        }).done(json => {
            let result = JSON.parse(json)
            if (result.Status === CONST.ApiResult.Success) {

                sessionStorage.setItem('DELIVERED_ITEMS', JSON.stringify(deliveredItems));
                sessionStorage.setItem('FACILITY_INFO', JSON.stringify(facility));

                handleRedirect(URLPath.IRC0111_2);
            } else {
                setStatusMessage(CONST.ApiResult.Error, result.Message);
            }
        }).fail(json => {
        }).always(json => {
            $("#loading").fadeOut();
        })
    }

    function renderRequestMailCheckbox() {
    return (
      <div>
        <div className="container" style={{ margin: "5px", width: isMobile ? "100%" : "auto", }}>
          <div className="col-sm-4 col-xs-4"></div>
          <div className={isMobile ? "col-xs-12" : "col-sm-4 col-xs-4" } 
          style={{paddingLeft: isMobile ? "0px" : "10%", whiteSpace:"nowrap",display: "flex", justifyContent: isMobile ? "center" : "flex-start"}}>
            <Checkbox
              value={sendDeleteCompletionEmail}
              name={"DelCompletionEmail"}
              label={getTranslateValue(translate.current, "views.irc0111.senddeletecompletionmail")}
              onChange={e => handleSendEmail()}
            />
          </div>
        </div>
      </div>
    );
    }

    function handleSendEmail() {
        setSendDeleteCompletionEmail(!sendDeleteCompletionEmail);
    }

    function renderSearchPanel() {
        return (
            <div>
                {renderFacilityInfo()}
                {renderOrdererInfo()}
            </div>
        );
    }

    function handleRedirect(path) {
        if (typeof path === 'string' || path instanceof String) {
            history.push(path);
        }
    }

    function renderFacilityInfo() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.facilityinfo")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.postalcode")}
                    name="postalcode"
                    value={facility.PostalCode}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.address")}
                    name="address"
                    value={facility.Address}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.facilityname")}
                    name="facilityname"
                    value={facility.FacilityName}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.phonenumber")}
                    name="phonenumber"
                    value={facility.Phone}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.fax")}
                    name="fax"
                    value={facility.Fax}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
            </div>
        );
    }

    function renderOrdererInfo() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.ordererinfo")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.kanjiname")}
                    name="kanjiname"
                    value={facility.KanjiName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.kananame")}
                    name="kananame"
                    value={facility.KanaName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.email")}
                    name="email"
                    value={facility.Email}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.irc0111.departmentname")}
                    name="departmentname"
                    value={facility.DepartmentName}
                    containerType={"label"}
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
            </div>
        );
    }

    function renderDeliveredMaterialsTable() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.irc0111.deliveredmaterials")}</legend>
                <IRC0111_1Table
                    data={deliveredItems}
                    pageNo={currentPage}
                    sizePerPage={sizePerPage}
                    isFetching={isFetching}
                    translate={translate}
                    setPageNo={setPageNo.bind(this)}
                    setSizePerPage={setSizePerPage.bind(this)}
                    getTranslateValue={getTranslateValue.bind(this)}
                />
            </div>
        );
    }

    function renderActionButtons() {
        return (
            <div className="row form-group">
                <div className="col-xs-4 text-left">
                    <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.irc0111.back")} onClick={handleRedirect.bind(this, URLPath.IRC0111)}  />
                </div>
                {/* Show Cancel Billing button only when there is no shuka record (first box red / other boxes hidden) */}
                {!facility.HasShuka && (
                    <div className={isMobile ? "col-xs-8 text-right" : "col-xs-4 text-center"}>
                        <Button color="Success" divClassName="" divStyle={{ width: '100%' }} style={{ width: 160 }} label={getTranslateValue(translate.current, "views.irc0111.executedeletion")} onClick={handleCancelBilling.bind(this)}/>
                    </div>
                )}
                {!isMobile && <div className="col-xs-4" />}
            </div>
        );
    }

    // function renderSteps() {
    //     const status = facility.IraiStatus; // 0, 1, 10, 11
    //     const isPendingState = status === 0 || status === 10 || status === 11;
    //     const showPendingVisual = isFacilityLoaded && isPendingState;
    //     const showThirdBox = isFacilityLoaded && !isPendingState;

    //     // If there is no shuka record, show only the first box (red) and hide others
    //     if (isFacilityLoaded && !facility.HasShuka) {
    //         return (
    //             <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 12 }}>
    //                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    //                     <button className="shipment-steps" style={{ border: "2px solid #c94b4b", background: "#f7e0e0", color: "#3a3a3a", borderRadius: 4 }}>{getTranslateValue(translate.current, "views.irc0111.billingreception")}</button>
    //                 </div>
    //             </div>
    //         );
    //     }

    //     return (
    //         <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 12 }}>
    //             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    //                 {/* First Box: Billing Reception */}
    //                 <button className="shipment-steps dashed">{getTranslateValue(translate.current, "views.irc0111.billingreception")}</button>
    //                 <img className="shipment-steps-arrow" src={window.domainDir + "img/big%20bell/arrow_forward.png"} />
    //                 {/* Second Box: Shipping in Progress */}
    //                 <button className="shipment-steps dashed" style={{ border: showPendingVisual ? "2px solid #c94b4b" : "", background: showPendingVisual ? "#f7e0e0" : "", color: showPendingVisual ? "#3a3a3a" : "", borderRadius: showPendingVisual ? 4 : "" }}>{getTranslateValue(translate.current, "views.irc0111.shippinginprogress")}</button>
    //                 {showThirdBox && <img className="shipment-steps-arrow" src={window.domainDir + "img/big%20bell/arrow_forward.png"} />}
    //             </div>
    //             {/* Third Box: Shipped — visible only when status is NOT pending */}
    //             {showThirdBox && (
    //                 <div style={{ border: "2px solid #c94b4b", background: "#f7e0e0", padding: "12px 30px", borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "space-between", minWidth: 450 }}>
    //                     <div style={{ fontWeight: 700, fontSize: 18, color: "#3a3a3a" }}>
    //                         {getTranslateValue(translate.current, "views.irc0111.shipped")} ({facility.DateShipped})
    //                     </div>
    //                     <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", fontSize: 13, color: "#333" }}>
    //                         <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
    //                             <div style={{ width: 110, textAlign: "right", paddingRight: 8, color: "#666" }}>{getTranslateValue(translate.current, "views.irc0111.deliverycompany")}：</div>
    //                             <div style={{ minWidth: 0 }}>{facility.DeliveryCompany}</div>
    //                         </div>
    //                         <div style={{ display: "flex", alignItems: "center" }}>
    //                             <div style={{ width: 110, textAlign: "right", paddingRight: 8, color: "#666" }}>{getTranslateValue(translate.current, "views.irc0111.invoicenumber")}：</div>
    //                             <div><a href="#" style={{ color: "#1a73e8", textDecoration: "underline" }}>{facility.InvoiceNumber}</a></div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             )}
    //         </div>
    //     );
    // }

    return (
        <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
            <ContentTitle active="#IRC0111" title={getTranslateValue(translate.current, "views.irc0111.confirmbillingdetails")} />
            {/* <div className="row" style={{ marginBottom: 30 }}>
                <div className="col-sm-4">
                    <div className="col-sm-4" >
                        <Button color="Default" className="flex-grow-0" label={getTranslateValue(translate.current, "views.irc0111.back")} onClick={handleRedirect.bind(this, URLPath.IRC0111)} />
                    </div>
                </div>
            </div> */}
            <div className="row form-group" style={{ marginTop: 30 }}>
                <div className="col-xs-4 text-left">
                    <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.irc0111.back")} onClick={handleRedirect.bind(this, URLPath.IRC0111)} />
                </div>
            </div>
            {/* {renderSteps()} */}
            <div className="main-content">
                <div className="container-fluid" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    {renderSearchPanel()}
                    {renderDeliveredMaterialsTable()}
                    <div style={{ height: 25 }} />
                    {renderRequestMailCheckbox()}
                    {renderActionButtons()}
                </div>
            </div>
        </Translate>
    )
}

export default IRC0111_1_Master;


// WEBPACK FOOTER //
// ./view/IRC0111_1/irc0111_1.jsx